// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1fi_A","inner":"Form_inner__xyfY5","range":"Form_range__3nmzt","name":"Form_name__2ePZd","actions":"Form_actions__1t0L1"};